import { createSelector } from '@reduxjs/toolkit';
import { selectUser } from './selectUser';

export const selectUserEmail = createSelector(selectUser, user => (user.isAuthenticated ? user.email : null));
